<template>
    <div>
        <input @change="changeValue()" style="border-bottom: #aaa 1px solid " v-model="newDate" type="date">
        <v-btn @click="onSave()"> Αποθήκευση </v-btn>
    </div>
</template>

<script>
    export default {
        name: "DatePicker",
        data: () => ({
            newDate: null,
            hasChanged: false,

        }),
        props: {date:String},
        mounted(){
            this.newDate = this.date;
        },
        methods: {
            changeValue() {
                this.hasChanged = true
            },
            onSave(){
                this.hasChanged = false;
                this.$emit('onSave',this.newDate)
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/DatePicker.vue